const NDD = () => {
	const nddTable = document.getElementById('nddTable');
	const jobForm = document.getElementById('jobForm');

	// Check the table exists
	if (!nddTable) {
		return;
	}

	if (!jobForm) {
		return;
	}

	// Get the facility from the job from data attribute
	const facility = jobForm.getAttribute('data-facility');

	if (facility === 'BAL') {
		// Show the NDD form
		const nddForm = document.getElementById('nddForm');
		nddForm.style.display = 'block';
	}

	const addLoadBtn = document.getElementById('addLoad');

	const tippingRate = parseFloat(nddTable.getAttribute('data-rate') || 0).toFixed(2);

	const tbody = nddTable.querySelector('tbody');

	const observerCallback = (mutationsList, observer) => {
		for (let mutation of mutationsList) {
			if (mutation.type === 'childList') {
				updateIndices();
				calculateGrandTotal();
			}

			if (mutation.type === 'attributes' && mutation.attributeName === 'data-facility') {
				const facility = mutation.target.getAttribute('data-facility');
				console.log('Data-facility changed:', facility);
				// Handle the change in the data-facility attribute
				// Get the NDD for by ID
				const nddForm = document.getElementById('nddForm');

				if (facility === 'BAL') {
					// Show the NDD form
					nddForm.style.display = 'block';
				} else {
					// Hide the NDD form
					nddForm.style.display = 'none';
				}

			}
		}
	};

	const observer = new MutationObserver(observerCallback);
	const config = { childList: true };

	// Start observing
	observer.observe(tbody, config);

	const facilityObserver = new MutationObserver(observerCallback);

	facilityObserver.observe(jobForm, {
		attributes: true, // Observe attributes
		attributeFilter: ['data-facility'] // Only observe changes to the data-facility attribute
	});

	const renderRow = (truck, index) => {
		const truckId = truck ? truck.truckId : '';
		const vehicleReg = truck ? truck.vehicleReg : '';
		const truckSize = truck ? truck.truckSize : 0;
		const total = truck ? (truckSize * tippingRate).toFixed(2) : '0.00';
		const hiddenId = truckId ? `<input type="hidden" name="trucks[${index}][id]" value="${truckId}">` : '';

		// Check if the truck has a docket cast to bool
		const hasDocket = truck ? truck.hasDocket : false;

		const uploadDocket = () => {
			let html = '';

			if (hasDocket) {
				html = truck.docket;
			} else {
				html = `<div class="file-upload-wrapper">
							<button type="button" data-action="uploadDocket" class="btn btn--primary">Upload Docket</button>
							<input type="file" name="trucks[${index}][docket]" id="file-input" class="file-input" accept="image/*,application/pdf" style="display: none;">
							<span class="file-name">No file chosen</span>
						</div>`;
			}

			return html;
		}

		return `<tr id="nddItem${index}" data-id="${truckId}" class="editable">
                <td>
                    <div class="form__group">
                        <input class="form__control" required type="text" name="trucks[${index}][vehicle_registration]" value="${vehicleReg}">
                        <input class="form__control" type="hidden" name="trucks[${index}][type]" value="ndd">
                        ${hiddenId}
                    </div>
                </td>
                <td>
                    <div class="form__input-group">
                        <input class="form__control" required type="number" name="trucks[${index}][truck_size]" value="${truckSize}">
                        <span class="input-group-text">t</span>
                    </div>
                </td>
                <td class="text-center">$${tippingRate}</td>
                <td class="total text-end">$${total}</td>
                <td class="text-center">
                	${uploadDocket()}
				</td>
                <td class="text-end">
                    <div class="options-menu">
                        <button id="nddMenuButton${index}" type="button" class="btn dropdown-toggle" data-bs-toggle="dropdown">
                            <i class="far fa-ellipsis-h"></i>
                        </button>
                        <ul class="dropdown-menu">
                            <li>
                                <a class="dropdown-item danger" href="#confirmRemoveTippingModal" data-bs-toggle="modal" data-ref="nddItem${index}" data-rego="${vehicleReg}">
                                    Delete
                                </a>
                            </li>
                        </ul>
                    </div>
                </td>
            </tr>`;
	}

	const editRow = (rowId) => {
		const row = document.getElementById(rowId);
		if (!row) return;

		// Extracting values directly from the table row's cells
		const vehicleReg = row.cells[0].textContent.trim();
		const truckSize = row.cells[1].textContent.trim();
		const truckId = row.getAttribute('data-id');

		// Check data attr for data-has-docket "true" or "false" and cast to bool
		const hasDocket = row.getAttribute('data-has-docket') === 'true';

		// You might need to convert these texts into a more structured form if they contain more than just the data
		// For example, if truckType is shown with additional text or labels in the UI, you'll need to parse it accordingl

		const truckData = {
			truckId,
			vehicleReg,
			truckSize,
			hasDocket
		};

		if (hasDocket) {
			truckData.docket = row.cells[4].innerHTML;
		}

		const rowIndex = Array.from(row.parentNode.children).indexOf(row);
		const editableRowHtml = renderRow(truckData, rowIndex);

		row.outerHTML = editableRowHtml;  // Replace with editable version

		row.outerHTML = editableRowHtml;  // Replace the entire row with an editable version

		updateIndices();
	}

	const updateIndices = () => {
		const rows = nddTable.querySelectorAll('tbody tr.editable');

		for (let i = 0; i < rows.length; i++) {
			const rowId = rows[i].querySelector('input[name*="[id]"]');
			rowId ? rowId.name = `trucks[${i}][id]` : null;
			rows[i].querySelector('input[name*="[vehicle_registration]"]').name = `trucks[${i}][vehicle_registration]`;
			rows[i].querySelector('input[name*="[truck_size]"]').name = `trucks[${i}][truck_size]`;

			if (rows[i].querySelector('input[name*="[docket]"]')) {
				rows[i].querySelector('input[name*="[docket]"]').name = `trucks[${i}][docket]`;
			}

			if (rows[i].querySelector('input[name*="[type]"]')) {
				rows[i].querySelector('input[name*="[type]"]').name = `trucks[${i}][type]`;
			}

		}
	}

	const calculateCosts = (e) => {
		const row = e.target.parentNode.parentNode.parentNode;
		const truckSize = row.querySelector('input[name*="[truck_size]"]').value;
		const totalCost = row.querySelector('.total');

		const cost = (truckSize * tippingRate).toFixed(2);
		totalCost.textContent = `$${cost}`;

		calculateGrandTotal();
	}

	const calculateGrandTotal = () => {
		const grandTotalEl = document.getElementById('nddGrandTotal');
		// Get all elements with class total from the table and sum them
		const totalCosts = Array.from(nddTable.getElementsByClassName('total'));
		const grandTotal = totalCosts.reduce((acc, el) => {
			return acc + parseFloat(el.textContent.replace('$', ''));
		}, 0).toFixed(2);

		grandTotalEl.textContent = `$${grandTotal}`;
	}

	const onTippingTableChange = (e) => {
		if (event.target.matches('input[name*="[truck_size]"]')) {
			calculateCosts(e);
		} else if (event.target.matches('input[name*="[loads]"]')) {
			calculateCosts(e);
		} else if (event.target.matches('input[name*="[vehicle_registration]"]')) {
			onRegistrationChange(e);
		}
	};

	const onRegistrationChange = (e) => {
		const row = e.target.parentNode.parentNode.parentNode;
		const truckRego = row.querySelector('input[name*="[vehicle_registration]"]').value;

		// Find the child href="#confirmRemoveContractorModal" of the row
		const deleteButton = row.querySelector('a[href="#confirmRemoveTippingModal"]');

		// Update the data-name attribute of the delete button
		deleteButton.setAttribute('data-rego', truckRego);
	}

	addLoadBtn.addEventListener('click', () => {
		const tableBody = nddTable.querySelector('tbody');
		const rowCount = tableBody.rows.length;
		const newRow = renderRow(null, rowCount);
		tableBody.insertAdjacentHTML('beforeend', newRow);
	});

	// Add event listener on change for additionalTippingTable select[name*="[truck_type]"]'
	// to calculate the total cost of tipping for each truck
	nddTable.addEventListener('change', onTippingTableChange);


	nddTable.addEventListener('click', (event) => {
		if (event.target.matches('[data-action="edit-tipping"]')) {
			const button = event.target;
			const ref = button.getAttribute('data-ref');
			const rego = button.getAttribute('data-rego');
			editRow(ref, rego);

		} else if (event.target.matches('[data-action="uploadDocket"]')) {
			event.target.nextElementSibling.click();
		}
	});

	nddTable.addEventListener('change', (event) => {
		if (event.target.matches('input[type="file"]')) {
			const removeFileBtn = document.createElement('button');
			const fileNameDisplay = event.target.nextElementSibling;

			removeFileBtn.classList.add('btn');
			removeFileBtn.textContent = 'X';
			removeFileBtn.style.marginLeft = '2px';

			removeFileBtn.addEventListener('click', (e) => {
				e.preventDefault();
				event.target.value = '';
				event.target.previousElementSibling.style.display = 'block';
				event.target.nextElementSibling.textContent = 'No file chosen';
				event.target.nextElementSibling.style.display = 'none';
				removeFileBtn.remove();
			});

			fileNameDisplay.textContent = 'Docket Attached';
			fileNameDisplay.appendChild(removeFileBtn);

			// Hide the upload button and show the filename
			event.target.previousElementSibling.style.display = 'none';
			fileNameDisplay.style.display = 'block';
		}

	});
}

export default NDD;